import { render, staticRenderFns } from "./change-purchase.vue?vue&type=template&id=710befa0"
import script from "./change-purchase.vue?vue&type=script&lang=js"
export * from "./change-purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710befa0')) {
      api.createRecord('710befa0', component.options)
    } else {
      api.reload('710befa0', component.options)
    }
    module.hot.accept("./change-purchase.vue?vue&type=template&id=710befa0", function () {
      api.rerender('710befa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/apply/change-purchase.vue"
export default component.exports